module.exports = __webpack_public_path__ + "img/cs-bongkasa.33dbfb13.jpeg";